import { useMemo } from "react"
import { OverlayTrigger, Tooltip } from "react-bootstrap"

import styles from "./LinkWithIcon.module.css"

interface LinkWithIconProps {
  title?: string
  color?: string
  onClick?: () => void
  href?: string
  target?: string
  rel?: string
  icon: React.ReactNode
  className?: string
  style?: React.CSSProperties
  tooltip?: string
  placement?: "top" | "bottom" | "left" | "right"
}

export default function LinkWithIcon({
  title,
  color,
  onClick,
  href,
  target,
  rel,
  icon,
  className,
  style,
  tooltip,
  placement = "top",
}: LinkWithIconProps) {
  const isExternalLink = !!href

  const content = (
    <div
      className={`${styles.link} ${className || ""} d-flex align-items-center ${
        !isExternalLink ? "cursor-pointer" : ""
      }`}
      style={{
        color: color || "black",
        ...style,
        width: "fit-content",
        display: "block",
      }}
      onClick={() => {
        if (!isExternalLink && onClick) {
          onClick()
        }
      }}
    >
      <div className={`${styles.link__icon} d-flex`}>{icon}</div>
      {title && <div>{title}</div>}
    </div>
  )

  const wrappedContent = useMemo(() => {
    if (!tooltip) return content

    return (
      <OverlayTrigger
        placement={placement}
        overlay={
          <Tooltip id="tooltip" className="custom-tooltip">
            {typeof tooltip === "string" || typeof tooltip === "number"
              ? tooltip
              : "Tooltip"}
          </Tooltip>
        }
      >
        <span
          style={{
            color: color || "black",
            ...style,
            width: "fit-content",
            display: "block",
          }}
        >
          {content}
        </span>
      </OverlayTrigger>
    )
  }, [tooltip, placement, content, color, style])

  if (isExternalLink) {
    return (
      <a
        style={{ width: "fit-content", display: "block" }}
        href={href}
        target={target || "_self"}
        rel={rel || "noopener noreferrer"}
        className="text-decoration-none"
      >
        {wrappedContent}
      </a>
    )
  }

  return wrappedContent
}
